import { AccessToken, Tokens } from "@okta/okta-auth-js";

interface IAuthTokenService {
    getToken(): string | null;
}

const KEY_OKTA_TOKEN: string = "okta-token-storage";

class AuthTokenService implements IAuthTokenService {

    getToken(): string | null {

        const accessToken = getAccessTokenFromStorage();

        if (accessToken?.accessToken == null) {
            return null;
        }

        if ((accessToken.expiresAt * 1000) < Date.now()) {
            return null;
        }

        return accessToken.accessToken;
    }
}

function getAccessTokenFromStorage(): AccessToken | null {
    const unparsedOktaToken = localStorage.getItem(KEY_OKTA_TOKEN);
    if (unparsedOktaToken == null) {
        return null;
    } else {
        const oktaToken: Tokens = JSON.parse(unparsedOktaToken);
        return oktaToken?.accessToken ?? null;
    }
}

const authTokenService: IAuthTokenService = new AuthTokenService();

export default authTokenService;